import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth-service/auth.service';
import { GapPermissionGuard } from './gap-permission.guard';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private readonly _authService: AuthService,
    private readonly _gapPermissionGuard: GapPermissionGuard,
    private readonly _router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    await this._authService.ready;

    if (!this._authService.isLoggedIn()) {
      this._authService.saveCurrentPathInSession();
      this._router.navigate(['/login']);
      return false;
    }
    // Without access to GAP, or at too low a level, the page would open only for its calls to be refused
    return this._gapPermissionGuard.check(state.url, route.data?.['requires']);
  }
}
